import { render } from "./ProductionTable.vue?vue&type=template&id=f5b54872&scoped=true&ts=true"
import script from "./ProductionTable.vue?vue&type=script&lang=ts"
export * from "./ProductionTable.vue?vue&type=script&lang=ts"

import "./ProductionTable.vue?vue&type=style&index=0&id=f5b54872&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b54872"]])

export default __exports__